<mat-form-field class="msac-form-field" floatLabel="never">
    <label>{{ label }}</label>
    <mat-select matInput [(ngModel)]="selectedValues" (openedChange)="selectOpenChanged($event)" multiple>
        <mat-select-trigger>
            {{
                selectedValues.length > 0
                    ? (getNameForValue(selectedValues[0]) | ceCustomerPrivacy: customerPrivacyFilter)
                    : ''
            }}
            <span *ngIf="selectedValues.length > 1" class="additional-selection">
                (+{{ selectedValues.length - 1 }}
                <span i18n>{selectedValues.length, plural, =1 {other} other {others}}</span>)
            </span>
        </mat-select-trigger>
        <div class="msac-search-wrapper">
            <div>
                <mat-form-field floatLabel="never" class="msac-search" style="margin: -1em 0 -1.25em">
                    <mat-icon matPrefix>search</mat-icon>
                    <input
                        #filterInput
                        matInput
                        (keydown)="$event.stopPropagation()"
                        (keyup)="filterInputKeyUp($event)"
                    />
                </mat-form-field>
            </div>
            <div>
                <div class="fx-row fx-layout-align-space-between-center">
                    <div>{{ selectedValues.length }} <span i18n="Info text|">selected</span></div>

                    <div *ngIf="filterText">
                        <a
                            color="accent"
                            class="select-all-button"
                            mat-button
                            (click)="selectAllFiltered()"
                            (keydown.enter)="selectAllFiltered()"
                            i18n="Link text|"
                            >Select all filtered</a
                        >
                    </div>
                    <div>
                        <a
                            color="accent"
                            [disabled]="selectedValues.length === 0"
                            class="select-all-button"
                            mat-button
                            (click)="clearSelectedClick()"
                            (keydown.enter)="clearSelectedClick()"
                            i18n="Link text|"
                            >Clear selected</a
                        >
                    </div>
                </div>
            </div>
        </div>
        <div>
            <mat-option
                *ngFor="let item of items; trackBy: trackByFn"
                [value]="item.value"
                [ngClass]="{ 'hidden-option': !filteredValues[item.value] }"
            >
                {{ item.name | ceCustomerPrivacy: customerPrivacyFilter }}
            </mat-option>
        </div>
    </mat-select>
</mat-form-field>
